<template>
  <v-text-field
    ref="input"
    v-currency="{
      ...options,
      ...(isDisabledDecimal ? {
        precision: {
          min: 0,
          max: 0
        }
      } : {})
    }"
    :value="formattedValue"
    :rules="computedRules"
    v-bind="filteredAttrs"
    v-on="{
      ...$listeners,
      input: onInput,
      change: onChange
    }"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: "VCurrencyField",
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    options: {
      type: Object,
      default: () => {}
    },
    isDisabledDecimal: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formattedValue: null
    };
  },
  computed: {
    // กรอง rules ออกจาก $attrs เพื่อไม่ให้ส่งไปยัง v-text-field ซ้ำ
    filteredAttrs() {
      const { rules, ...attrs } = this.$attrs;
      return attrs;
    },
    // Expose input ref for parent components
    $input() {
      return this.$refs.input;
    },
    // แปลง rules ให้รับ number value แทน string
    computedRules() {
      if (!this.$attrs.rules) return [];
      
      // เช็คว่า rules เป็น array
      const rules = Array.isArray(this.$attrs.rules) ? this.$attrs.rules : [this.$attrs.rules];
      
      return rules
        .filter(rule => typeof rule === 'function') // กรองเฉพาะ function
        .map(rule => {
          return (formattedValue) => {
            // เช็คว่า ref มีค่าแล้วหรือยัง ถ้าไม่มีให้ใช้ fallback การแปลง
            if (!this.$refs.input) {
              // ใช้การแปลงแบบ manual ถ้า ref ยังไม่พร้อม
              const numValue = typeof formattedValue === 'string' ? 
                parseFloat(formattedValue.replace(/[^0-9.-]/g, '')) || 0 : 
                (formattedValue || 0);
              return rule(numValue);
            }
            
            // ใช้ getValue เพื่อแปลง formatted string เป็น number
            const numberValue = this.$ci.getValue(this.$refs.input);
            return rule(numberValue);
          };
        });
    }
  },
  watch: {
    value(newValue) {
      this.setValue(newValue);
      // อัพเดท formattedValue ทันทีเมื่อ value เปลี่ยน
      if (newValue === "" || newValue === null || newValue === undefined) {
        this.formattedValue = "";
      }
    }
  },
  mounted() {
    this.setValue(this.value);
    this.$nextTick(() => {
      this.resetValidation();
    });
  },
  methods: {
    setValue(value) {
      // ถ้า value เป็น "", null, undefined ให้ clear input
      if (value === "" || value === null || value === undefined) {
        this.$ci.setValue(this.$refs.input, null);
        this.formattedValue = "";
      } else {
        this.$ci.setValue(this.$refs.input, value);
      }
    },
    onInput(value) {
      this.$emit("input", this.$ci.getValue(this.$refs.input));
      this.formattedValue = value;
    },
    onChange(value) {
      this.$emit("change", this.$ci.getValue(this.$refs.input));
      this.formattedValue = value;
    },
    resetValidation() {
      if (this.$refs.input && this.$refs.input.resetValidation) {
        this.$refs.input.resetValidation();
      }
    },
    reset() {
      if (this.$refs.input && this.$refs.input.reset) {
        this.$refs.input.reset();
      }
      this.formattedValue = "";
      this.$emit("input", null);
    },
    validate() {
      if (this.$refs.input && this.$refs.input.validate) {
        return this.$refs.input.validate();
      }
      return true;
    },
    focus() {
      if (this.$refs.input && this.$refs.input.focus) {
        this.$refs.input.focus();
      }
    },
    blur() {
      if (this.$refs.input && this.$refs.input.blur) {
        this.$refs.input.blur();
      }
    }
  }
};
</script>
